import { BaseApi } from './base.api'

export class ReleaseAdminApi extends BaseApi {
	constructor() {
		super('api/admin/release')
	}

	async getReleaseItems() {
		return this.get('')
	}

	async createReleaseItem(data) {
		return this.post('', data)
	}

	async updateReleaseItem(id, data) {
		return this.put(`/${id}`, data)
	}

	async deleteReleaseItem(id) {
		return this.delete(`/${id}`)
	}
}
